import { render } from "./TaxModal.vue?vue&type=template&id=5b9739c4"
import script from "./TaxModal.vue?vue&type=script&lang=js"
export * from "./TaxModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nakarinjaiseengam/Works/Electroic-demo/STM-POS/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__